module.exports = ".cot-tab-label, .cot-parental-consent-button {\n  font-weight: bold; }\n\n.cot-tab-content {\n  padding-top: 30px;\n  overflow: hidden; }\n\n.cot-tab-invalid, .cot-parental-consent-error {\n  color: red; }\n\n.cot-parental-consent-error {\n  font-style: italic; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/cot-parental-consent-form/cot-parental-consent-form.component.scss
// module id = ./src/app/widgets/cot-parental-consent-form/cot-parental-consent-form.component.scss
// module chunks = main